import http, { HttpSuccessOrErrorType } from '../http';

const api = {
    /**
     * 获取shark 解密后密码
     * @param params 
     * @returns 
     */
    async get_shark_decryption_password(params: { shark_password: string }): Promise<HttpSuccessOrErrorType<string>> {
        return await http.get(`/core/shark/decryption/password`, {
            params
        })
    }
}

export default api;